module.exports = __webpack_public_path__ + "img/ic-discover-no-color.73632d29.svg";